import { createAction } from 'redux-actions';
import {
  FETCH_COURSES_INIT,
  ADD_POST_INIT,
  FETCH_FORUM_INIT,
  FETCH_TERMS_INIT,
} from '../actionTypes';

export const fetchCourses = createAction(FETCH_COURSES_INIT);
export const addPost = createAction(ADD_POST_INIT);
export const fetchForum = createAction(FETCH_FORUM_INIT);
export const fetchTerms = createAction(FETCH_TERMS_INIT);
